import { CurrentUserOrganizationDto } from '@sib/api';
import { cn } from '@sib/ui';
import { CircleCheck, Circle } from '@sib/ui/icons';

interface OrganizationListItemProps {
  organization: CurrentUserOrganizationDto;
  onSelect: (organization: CurrentUserOrganizationDto) => void;
  isSelected: boolean;
}

export const OrganizationListItem = ({
  isSelected,
  organization,
  onSelect,
}: OrganizationListItemProps) => {
  const iconSizing = 'size-[15px] min-w-[15px] sm:size-[22px] sm:min-w-[22px]';

  return (
    <div
      className="grid h-[46px] cursor-pointer items-center gap-2 px-3 py-2 even:bg-[#F6F8FA] sm:grid-cols-3"
      onClick={() => onSelect(organization)}
    >
      <div className="col-span-2 flex w-full items-center gap-2.5">
        {isSelected ? (
          <CircleCheck className={cn('text-secondary', iconSizing)} />
        ) : (
          <Circle className={cn('text-primary', iconSizing)} />
        )}
        <p className="text-primary text-sm font-semibold text-nowrap">
          {organization.name}
        </p>
      </div>
      <p className="text-muted-foreground hidden w-full truncate text-xs sm:block sm:text-sm">
        {organization.id}
      </p>
    </div>
  );
};
